import { createAsyncThunk } from '@reduxjs/toolkit';
import { TRACKING_MSGS_MAP, getShippingSelectorLabel } from '../helpers';
import { gaTrack } from '../utils';
import { EVENTS_NAMES_MAP } from '../events-name';

/**
 * @description track shipping selector event
 * @note GA event : trackEvent (zipcode_shipping_calculator) => 1. click_shipping_calculator 2. submit_shipping_calculator
 * @scenario 1. Triggered when a user clicks the  `quick ship` button in the PLP page
 * @scenario 2. Triggered when a user clicks the `shipping calculator` button in the PDP page or cart page or checkout page
 * @scenario 3. Triggered when a user submits the shipping calculator form in the shipping calculator popup
 * */
export const trackShippingSelectorEvent = createAsyncThunk(
  'tracking/trackShippingSelectorEvent',
  async (payload: { action: string; label?: string }, { getState, dispatch, fulfillWithValue }) => {
    if (!payload.action) {
      return fulfillWithValue(TRACKING_MSGS_MAP.TRACKING_ERROR);
    }
    const defaultLabel = getShippingSelectorLabel();
    const params = {
      event: EVENTS_NAMES_MAP.GA_CUSTOM_TRACK_EVENT,
      'eventDetails.category': 'zipcode_shipping_calculator',
      'eventDetails.action': payload.action, // click_shipping_calculator, submit_shipping_calculator
      'eventDetails.label': payload.label || defaultLabel,
    };
    gaTrack(params);
    return fulfillWithValue(TRACKING_MSGS_MAP.TRACKING_SUCCESS);
  }
);
